import * as React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { injectStore } from "./config/axiosConfig";
import store from "@store/store";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./utils/theme";
import "./App.scss";
import Launching from "@components/Launching/launching";
import { getCookie, setCookie } from "./utils/cookies";
dayjs.extend(customParseFormat);

const App = () => {
  injectStore(store);
  const [showLaunching, setShowLaunching] = React.useState(false);

  React.useEffect(() => {
    const isLaunchEnabled = process.env.REACT_APP_LAUNCHING_SCREEN === "true";

    const hasLaunched = getCookie("launchingScreen");

    setShowLaunching(isLaunchEnabled && !hasLaunched);
  }, []);

  React.useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {showLaunching && (
          <Launching onComplete={() => setShowLaunching(false)} />
        )}
        <Router>
          {/* <ScrollToTop /> */}
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </>
  );
};

export default App;
